import React from "react";
import {connect} from "react-redux";
import {Dialog, Button, Typography, TextField, Box, Paper} from "@material-ui/core";
import {CheckCircle, Cancel} from '@material-ui/icons';
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import axios from "axios";
import {userService} from "../services/UserService";
import config from '../config.json';
import {INotificacion, IParcela} from "../types";
import UnnamedImage from "../icons/PNGs/unnamed.png";

import DateUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker, KeyboardDateTimePicker} from "@material-ui/pickers";



interface IProps {
    data: Record<string, any>
    close(): void
    notify(notification: INotificacion): void
}

interface IState {
    date: Date
    text: string
    clickedText: boolean
    hover: string
    imageUrl: string
    id: string
    vertical: boolean
    cambiando: boolean
}

class MobileCrearNota extends React.Component<IProps, IState>{

    state:IState = {
        date: new Date(),
        text: '',
        clickedText: false,
        hover: '',
        imageUrl: '',
        id: '',
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false
    }

    handleImage = (e: any) => {

        if (this.state.imageUrl.length !== 0) {
            const nombre = this.state.id+'.'+e.target.files[0].name.split('.')[e.target.files[0].name.split('.').length-1]
            const parcela = this.props.data.parcela
            const path = `static/visualizador/notas/${userService.getUser()}/${parcela}/${nombre}`
            axios.get(
                config.url+`/note/image/remove?path=${path}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then(() => {})
                .catch(() => {})
        }

        const data = new FormData();
        data.append('file', e.target.files[0]);
        const parcela = this.props.data.parcela
        const id = `${userService.getUser()}_` + Date.now().toString()
        this.setState({id: id})
        const nombre = id+'.'+e.target.files[0].name.split('.')[e.target.files[0].name.split('.').length-1]
        const url = config.url+`/note/image/upload?parcela=${parcela}&nombre=${nombre}`
        axios.post(
            url,
            data,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                this.setState({imageUrl: config.url+`/static/visualizador/notas/${userService.getUser()}/${parcela}/${nombre}`})
            })
            .catch(() => {
            })
    }

    handleClick = () => {
        if (this.state.hover === 'text' && !this.state.clickedText) this.setState({clickedText: true})
        if (this.state.hover !== 'text' && this.state.clickedText) this.setState({clickedText: false})
    }

    crearNota = () => {
        if (this.state.text.length === 0) {
            this.props.notify({message: 'No has introducido ningún texto', variant: 'warning'})
            return
        }
        const data = {
            id: this.state.id.length === 0? `${userService.getUser()}_` + Date.now().toString() : this.state.id,
            parcela: this.props.data.parcela,
            lat: this.props.data.coords.lat,
            lng: this.props.data.coords.lng,
            date: this.state.date.toString(),
            text: this.state.text,
            image: this.state.imageUrl
        }
        axios.post(
            config.url+'/create/note',
            data,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {

                this.setState({imageUrl: '', id: ''})
                this.props.notify({message: 'Nota de campo guardada correctamente', variant: 'success'})
                this.props.close()
            })
            .catch(() => {
                this.props.notify({message: 'Error interno al guardar nota de campo', variant: 'error'})
            })

    }

    render() {

        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false);

        if (this.state.cambiando) {
            return null
        }

        if (this.state.vertical) {
            return (
                <Dialog
                    open={Object.keys(this.props.data).length !== 0}
                    maxWidth={false}
                    PaperProps={{
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: "center",
                            height: 'fit-content',
                            width: 'fit-content',
                            overflowX: "hidden"
                        }
                    }}
                    onClick={() => this.handleClick()}
                >
                    <link rel="stylesheet"
                          href="https://fonts.googleapis.com/css?family=Poppins"
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: 'fit-content',
                            height: 'fit-content',
                            overflow: "auto"
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 32,
                                fontWeight: "bold",
                                marginTop: 60,
                                width: '100%',
                                textAlign: "center",
                                color: '#4C494B',
                                fontFamily: "Poppins"
                            }}
                        >
                            Nueva Nota de Campo
                        </Typography>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: 'fit-content',
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: 50,
                                marginRight: 50
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: '80vw',
                                    marginLeft: 80,
                                    marginTop: 40,
                                    marginRight: 80,
                                    marginBottom: 40
                                }}
                            >

                                <div>
                                    <MuiPickersUtilsProvider
                                        utils={DateUtils}
                                    >
                                        <KeyboardDateTimePicker
                                            variant="inline"
                                            ampm={false}
                                            label="Fecha y Hora"
                                            value={this.state.date}
                                            onChange={(f) => {
                                                if (f !== null) this.setState({date: f.toDate()})
                                            }}
                                            format="YYYY/MM/DD HH:mm"
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>

                                <TextField
                                    style={{
                                        marginTop: 20
                                    }}
                                    inputProps={{style: {
                                            fontFamily: "Poppins",
                                            color: this.state.text.length === 0 && !this.state.clickedText? '#888' : "#000"
                                        }}}
                                    variant={"outlined"}
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={16}
                                    value={this.state.text.length === 0 && !this.state.clickedText?
                                        'Texto...'
                                        :
                                        this.state.text
                                    }
                                    onChange={e => this.setState({text: e.target.value})}
                                    onMouseEnter={() => this.setState({hover: 'text' as string})}
                                    onMouseLeave={() => this.setState({hover: ''})}
                                />

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 'fit-content',
                                    maxWidth: '80vw',
                                    overflow: "auto",
                                    marginLeft: 80,
                                    marginRight: 80,
                                    marginBottom: 40
                                }}
                            >
                                <input
                                    accept="image/png, image/jpeg, image/jpg"
                                    style={{
                                        display: 'none',
                                    }}
                                    id="image"
                                    type="file"
                                    onChange={(e) => this.handleImage(e)}
                                />
                                <label htmlFor="image">
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: 5,
                                            width: "fit-content",
                                            height: 40,
                                            borderStyle: "solid",
                                            borderWidth: this.state.hover === 'image'? 2:1,
                                            borderColor: this.state.hover === 'image'? '#80ED99':'#888',
                                            borderRadius: 5
                                        }}
                                        onMouseEnter={() => this.setState({hover: 'image' as string})}
                                        onMouseLeave={() => this.setState({hover: ''})}
                                    >
                                        <Typography
                                            style={{
                                                color: this.state.hover === 'image'? '#80ED99':'#4C494B',
                                                fontFamily: "Poppins",
                                                fontWeight: "bold",
                                                marginLeft: 10,
                                                marginRight: 10,
                                                cursor: "pointer"
                                            }}
                                        >
                                            Subir una imagen
                                        </Typography>
                                    </div>
                                </label>
                                {this.state.imageUrl.length !== 0 ?
                                    <img
                                        style={{
                                            height: 350,
                                            width: "fit-content"
                                        }}
                                        src={this.state.imageUrl}
                                        alt={'La imagen no funciona'}
                                    />
                                    :
                                    <img
                                        style={{
                                            height: 350,
                                            width: "fit-content"
                                        }}
                                        src={UnnamedImage}
                                        alt={'La imagen no funciona'}
                                    />
                                }
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                justifyContent: 'space-between',
                                marginBottom: 40
                            }}
                        >
                            <Button
                                style={{
                                    marginLeft: 120
                                }}
                                onClick={() => {
                                    this.setState({imageUrl: '', id: ''})
                                    this.props.close()
                                }}
                            >
                                <Cancel
                                    style={{
                                        height: 80,
                                        width: 80,
                                        color: "#ff5b5b"
                                    }}
                                />
                            </Button>
                            <Button
                                style={{
                                    marginRight: 120
                                }}
                                onClick={() => this.crearNota()}
                            >
                                <CheckCircle
                                    style={{
                                        height: 80,
                                        width: 80,
                                        color: "#80ED99"
                                    }}
                                />
                            </Button>
                        </div>

                    </div>

                </Dialog>
            )
        } else {
            return (
                <Dialog
                    open={Object.keys(this.props.data).length !== 0}
                    maxWidth={false}
                    PaperProps={{
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: "center",
                            overflow: "hidden",
                            height: 'fit-content',
                            width: 'fit-content'
                        }
                    }}
                    onClick={() => this.handleClick()}
                >
                    <link rel="stylesheet"
                          href="https://fonts.googleapis.com/css?family=Poppins"
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: 'fit-content',
                            height: 'fit-content'
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 32,
                                fontWeight: "bold",
                                marginTop: 60,
                                width: '100%',
                                textAlign: "center",
                                color: '#4C494B',
                                fontFamily: "Poppins"
                            }}
                        >
                            Nueva Nota de Campo
                        </Typography>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 'fit-content',
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: '30vw',
                                    marginLeft: 80,
                                    marginTop: 40,
                                    marginRight: 20,
                                    marginBottom: 20
                                }}
                            >

                                <div>
                                    <MuiPickersUtilsProvider
                                        utils={DateUtils}
                                    >
                                        <KeyboardDateTimePicker
                                            variant="inline"
                                            ampm={false}
                                            label="Fecha y Hora"
                                            value={this.state.date}
                                            onChange={(f) => {
                                                if (f !== null) this.setState({date: f.toDate()})
                                            }}
                                            format="YYYY/MM/DD HH:mm"
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>

                                <TextField
                                    style={{
                                        marginTop: 20
                                    }}
                                    inputProps={{style: {
                                            fontFamily: "Poppins",
                                            color: this.state.text.length === 0 && !this.state.clickedText? '#888' : "#000"
                                        }}}
                                    variant={"outlined"}
                                    id="outlined-multiline-static"
                                    multiline
                                    rows={16}
                                    value={this.state.text.length === 0 && !this.state.clickedText?
                                        'Texto...'
                                        :
                                        this.state.text
                                    }
                                    onChange={e => this.setState({text: e.target.value})}
                                    onMouseEnter={() => this.setState({hover: 'text' as string})}
                                    onMouseLeave={() => this.setState({hover: ''})}
                                />

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 'fit-content',
                                    marginRight: 80,
                                    marginTop: 60,
                                    marginLeft: 20,
                                    marginBottom: 20
                                }}
                            >
                                <input
                                    accept="image/png, image/jpeg, image/jpg"
                                    style={{
                                        display: 'none',
                                    }}
                                    id="image"
                                    type="file"
                                    onChange={(e) => this.handleImage(e)}
                                />
                                <label htmlFor="image">
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: 5,
                                            width: "fit-content",
                                            height: 40,
                                            borderStyle: "solid",
                                            borderWidth: this.state.hover === 'image'? 2:1,
                                            borderColor: this.state.hover === 'image'? '#80ED99':'#888',
                                            borderRadius: 5
                                        }}
                                        onMouseEnter={() => this.setState({hover: 'image' as string})}
                                        onMouseLeave={() => this.setState({hover: ''})}
                                    >
                                        <Typography
                                            style={{
                                                color: this.state.hover === 'image'? '#80ED99':'#4C494B',
                                                fontFamily: "Poppins",
                                                fontWeight: "bold",
                                                marginLeft: 10,
                                                marginRight: 10,
                                                cursor: "pointer"
                                            }}
                                        >
                                            Subir una imagen
                                        </Typography>
                                    </div>
                                </label>
                                {this.state.imageUrl.length !== 0 ?
                                    <img
                                        style={{
                                            height: 350,
                                            width: "fit-content"
                                        }}
                                        src={this.state.imageUrl}
                                        alt={'La imagen no funciona'}
                                    />
                                    :
                                    <img
                                        style={{
                                            height: 350,
                                            width: "fit-content"
                                        }}
                                        src={UnnamedImage}
                                        alt={'La imagen no funciona'}
                                    />
                                }
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                justifyContent: 'space-between',
                                marginBottom: 40
                            }}
                        >
                            <Button
                                style={{
                                    marginLeft: 80,
                                    marginRight: 20
                                }}
                                onClick={() => {
                                    this.setState({imageUrl: '', id: ''})
                                    this.props.close()
                                }}
                            >
                                <Cancel
                                    style={{
                                        height: 80,
                                        width: 80,
                                        color: "#ff5b5b"
                                    }}
                                />
                            </Button>
                            <Button
                                style={{
                                    marginLeft: 20,
                                    marginRight: 80
                                }}
                                onClick={() => this.crearNota()}
                            >
                                <CheckCircle
                                    style={{
                                        height: 80,
                                        width: 80,
                                        color: "#80ED99"
                                    }}
                                />
                            </Button>
                        </div>

                    </div>

                </Dialog>
            )
        }
    }
}

const mapStateToProps = (state: IStore) => ({
    data: state.navegacion.dialogs.crear_nota
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: () => dispatch({type: "open-crear-nota-dialog", callback: {} as Record<string, any>}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileCrearNota);